/**
 * Application Router
 * Handles client-side routing between pages
 */

import { Routes, Route } from 'react-router-dom'
import { ROUTES } from './routes'
import { DevApiPage, WorkQueuePage } from '../pages'

export function AppRouter() {
  return (
    <Routes>
      <Route path={ROUTES.WORK_QUEUE} element={<WorkQueuePage />} />
      <Route path={ROUTES.DEV_API} element={<DevApiPage />} />
    </Routes>
  )
}
